import { FileType } from '@office-start/document-types';
import { appendAndReplaceQueryParams } from '@office-start/url-parser-utility';
import { DESIGNER_MOBILE_URL, DESIGNER_URL } from '../constants';
import { appendQueryInformation } from '../utilities/appendQueryInformation';
import { getFormAuthenticatedCdn } from '../utilities/getFormAuthenticatedCdn';
export function getCreateFormsLink(formsOptions, fileType, newFileName, groupId, area) {
    var actions = {
        CreateSurvey: 'Create',
        CreateQuiz: 'CreateQuiz',
    };
    var fragmentTemplate = function (title, action, grpId) {
        return "Action=".concat(action, "&Title=").concat(title).concat(grpId ? '&GroupId=' + grpId : '');
    };
    var url = getFormAuthenticatedCdn(formsOptions, false);
    var params = {
        Action: null,
        Fragment: null,
    };
    if (fileType === FileType.Forms) {
        params.Fragment = fragmentTemplate(newFileName, actions.CreateSurvey, groupId);
        params.Action = actions.CreateSurvey;
    }
    else {
        // Currently, for Mobile Quiz Creation, Forms not support MobileDesignPage.
        url = url.replace(DESIGNER_MOBILE_URL, DESIGNER_URL);
        params.Fragment = fragmentTemplate(newFileName, actions.CreateQuiz, groupId);
        params.Action = actions.CreateQuiz;
    }
    url = appendAndReplaceQueryParams(url, params, true);
    return appendQueryInformation(formsOptions.componentContext, url, true, area);
}
//# sourceMappingURL=getCreateFormsLink.js.map